import React, { useEffect, useState } from "react";
import DefaultPagination from "./DefaultPagination";
import {
  fetchInStoreOrderData,
  updateInstoreOrderDataState,
} from "../../../Redux/features/Orders/inStoreOrderSlice";
import { useSelector, useDispatch } from "react-redux";
import DownIcon from "../../../Assests/Dashboard/Down.svg";
import { Link, useNavigate } from "react-router-dom";
import { renderToString } from "react-dom/server";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Grid } from "@mui/material";

// import $ from "jquery";
// import "datatables.net-dt/css/jquery.dataTables.min.css";
import { saveBulkInstantPo } from "./../../../Redux/features/Product/ProductSlice";
import Pagination from "../../../AllUserComponents/Users/UnverifeDetails/Pagination";
import { SkeletonTable } from "../../../reuseableComponents/SkeletonTable";
import { getOrderListCount } from "../../../Redux/features/Orders/inStoreOrderSlice";
import useDebounce from "../../../hooks/useDebouncs";
import { SortTableItemsHelperFun } from "../../../helperFunctions/SortTableItemsHelperFun";
import sortIcon from "../../../Assests/Category/SortingW.svg";

import PasswordShow from "../../../Common/passwordShow";
import NoDataFound from "../../../reuseableComponents/NoDataFound";
import {
  formatDateNumeric,
  formatDateTime,
  transactionType,
} from "../../../Constants/utils";
import { format } from "date-fns";
import HoverInfoLogo from "../../../reuseableComponents/HoverInfoLogo";
import { formatPhoneNumber } from "../../../helperFunctions/formatPhoneNumber";
const StyledTable = styled(Table)(({ theme }) => ({
  padding: 2, // Adjust padding as needed
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--qv-bg-253338, #253338)",
    color: theme.palette.common.white,
    fontFamily: "CircularSTDMedium !important",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook !important",
  },
  [`&.${tableCellClasses.table}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook !important",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    // backgroundColor: "var(--qv-bg-f5f5f5, #F5F5F5)",
  },
  "& td, & th": {
    borderBottom: "1px solid #E8E8E8",
  },
}));

const InstoreTableViewData = (props, searchId) => {
  const navigate = useNavigate();
  const { handleCoockieExpire, getUnAutherisedTokenMessage, getNetworkError } =
    PasswordShow();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [inStoreOrder, setAllInStoreOrders] = useState([]);
  // console.log("inStoreOrder totalCount", totalCount);
  const AllInStoreDataState = useSelector((state) => state.inStoreOrder);
  const [selectedValue, setSelectedValue] = useState(1);
  const dispatch = useDispatch();
  const debouncedValue = useDebounce(props?.OffSearchIdData);
  // console.log("debouncedValue", debouncedValue);
  const handleChange = (event) => {
    setSelectedValue(parseInt(event.target.value));
  };
  // const numberOptions = [];
  // for (let i = 1; i <= 50; i++) {
  //   numberOptions.push(
  //     <option key={i} value={i}>
  //       {i}
  //     </option>
  //   );
  // }
  useEffect(() => {
    setCurrentPage(1);
    const transactionType = (type) => {
      if (type === "Cash") {
        return "Cash";
      } else if (type === "Credit Card") {
        return "Online";
      } else if (type === "Cash & Credit Card") {
        return "Both";
      } else {
        return type;
      }
    };
    if (
      props?.selectedDateRange?.start_date &&
      (props.selectedInStoreTransactionsList.length !== 0 ||
        props.selectedInStoreEmployeeList.length !== 0)
    ) {
      dispatch(
        getOrderListCount({
          merchant_id: props.merchant_id, //
          order_type: "Offline",
          search_by:
            props?.OffSearchIdData !== "" ? props?.OffSearchIdData : null,
          // trans_type: transactionType(props.OrderSourceData), //
          trans_type: "Both", //
          start_date: props.selectedDateRange?.start_date, //
          end_date: props.selectedDateRange?.end_date, //
          order_method: props.order_method ? props.order_method : "All",
          payment_type:
            // "All" only when every option (incl. Unpaid for superadmin) is
            // selected; the default all-except-Unpaid selection sends the
            // explicit list so unpaid orders stay excluded.
            props?.enhancedInStoreTransactionsList.length ===
            props?.selectedInStoreTransactionsList.length
              ? "All"
              : props.selectedInStoreTransactionsList.length > 0
                ? props.selectedInStoreTransactionsList
                    ?.map((item) => item.apivalue)
                    .join(", ")
                : "",
          // emp_id: props?.EmployeeIDData==="All Employees" ?"All" :props?.EmployeeIDData,
          emp_id:
            props?.employeeList.length ===
            props.selectedInStoreEmployeeList.length
              ? "All"
              : props?.selectedInStoreEmployeeList.length !== 0
                ? props?.selectedInStoreEmployeeList
                    .map((emp) => `${emp.id}`)
                    .join(",")
                : "",
          ...props.userTypeData, //
        })
      );
    }
  }, [
    dispatch,
    props.selectedDateRange,
    // props.selectedDateRange?.start_date,
    // props.selectedDateRange?.end_date,
    debouncedValue,
    props.order_method,
    // props?.EmployeeIDData,
    props.selectedInStoreTransactionsList,
    props.selectedInStoreEmployeeList,
    // props.OrderSourceData,

    // AllInStoreDataState.OrderListCount,
    // AllInStoreDataState.inStoreOrderData,
  ]);

  useEffect(() => {
    fetchData();
  }, [
    // dispatch,
    // props,
    debouncedValue,
    props.selectedDateRange,
    currentPage,
    rowsPerPage,
    // props?.EmployeeIDData,
    props.selectedInStoreTransactionsList,
    props.selectedInStoreEmployeeList,
    // AllInStoreDataState.OrderListCount,
  ]);
  const fetchData = async () => {
    const transactionType = (type) => {
      if (type === "Cash") {
        return "Cash";
      } else if (type === "Credit Card") {
        return "Online";
      } else if (type === "Cash & Credit Card") {
        return "Both";
      } else {
        return type;
      }
    };
    if (
      props?.selectedDateRange?.start_date &&
      (props.selectedInStoreTransactionsList.length !== 0 ||
        props.selectedInStoreEmployeeList.length !== 0)
    ) {
      let data = {
        merchant_id: props.merchant_id,
        order_type: "Offline",
        // trans_type: transactionType(props.OrderSourceData), //
        trans_type: "Both", //
        start_date: props.selectedDateRange?.start_date,
        end_date: props.selectedDateRange?.end_date,
        // emp_id:
        //   props?.EmployeeIDData === "All Employees"
        //     ? "All"
        //     : props?.EmployeeIDData,
        emp_id:
          props?.employeeList.length ===
          props.selectedInStoreEmployeeList.length
            ? "All"
            : props?.selectedInStoreEmployeeList.length !== 0
              ? props?.selectedInStoreEmployeeList
                  .map((emp) => `${emp.id}`)
                  .join(",")
              : "",
        search_by:
          props?.OffSearchIdData !== "" ? props?.OffSearchIdData : null,
        perpage: rowsPerPage,
        page: debouncedValue === "" ? currentPage : "1",
        order_method: props.order_method ? props.order_method : "All",
        payment_type:
          // Same rule as the count effect above.
          props?.enhancedInStoreTransactionsList.length ===
          props?.selectedInStoreTransactionsList.length
            ? "All"
            : props.selectedInStoreTransactionsList.length > 0
              ? props.selectedInStoreTransactionsList
                  ?.map((item) => item.apivalue)
                  .join(", ")
              : "",
        order_by: sortOrder.toUpperCase(),
        filter_by:
          filter_by === "name"
            ? `users.${filter_by}`
            : filter_by === "f_name"
              ? `employee.${filter_by}`
              : `my_order.${filter_by}`,
      };
      // console.log("date data", data);
      if (data) {
        try {
          await dispatch(fetchInStoreOrderData(data)).unwrap();
        } catch (error) {
          if (error?.status == 401) {
            getUnAutherisedTokenMessage();
            handleCoockieExpire();
          } else if (error?.status == "Network Error") {
            getNetworkError();
          }
        }
      }
    } else {
      dispatch(updateInstoreOrderDataState());
    }
  };

  useEffect(() => {
    if (props?.activeTab == "offline") {
      // setTotalCount(AllInStoreDataState?.inStoreOrderData?.length);
      setTotalCount(AllInStoreDataState?.OrderListCount);
    } else {
      setTotalCount(AllInStoreDataState?.OrderListCount);
    }
  }, [
    AllInStoreDataState.OrderListCount,
    AllInStoreDataState?.inStoreOrderData,
  ]);

  useEffect(() => {
    props.setIsLoading(AllInStoreDataState.loading);
    if (!AllInStoreDataState.loading && AllInStoreDataState.inStoreOrderData) {
      setAllInStoreOrders(AllInStoreDataState.inStoreOrderData);
    }
  }, [AllInStoreDataState.loading, AllInStoreDataState.inStoreOrderData]);

  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
  };

  // for table start
  // $.DataTable = require("datatables.net");
  // console.log(inStoreOrder)
  // useEffect(() => {
  //   const modifiedData = inStoreOrder.map((data) => ({
  //     Customer: `<span className="text-[#000000] order_method">${
  //       data.billing_name || ""
  //     }</span><br><span className="text-[#818181]">${
  //       data.delivery_phn || ""
  //     }</span>`,
  //     Order: `<span className="text-[#000000] order_method">${
  //       data.order_id || ""
  //     }</span><br><span className="text-[#818181]">${
  //       data.merchant_time || ""
  //     }</span><br><span className="text-[#818181]">${
  //       data.order_method || ""
  //     }</span>`,
  //     Amount: `${
  //       data.amt || ""
  //     }<br><span className="text-[#1EC26B]">${capitalizeFirstLetter(
  //       data.order_status || ""
  //     )}</span>`,

  //     // "Status": `<span className="text-[#000000]">${data.order_status || ""}</span>`,
  //     View: `<a href="/store-reporting/order-summary/${data.order_id}" className="view_details_order">View Details</a>`,
  //   }));

  //   const table = $("#InstoreTable").DataTable({
  //     data: modifiedData,
  //     columns: [
  //       { title: "Customer", data: "Customer", orderable: false },
  //       { title: "Order", data: "Order", orderable: false },
  //       { title: "Amount", data: "Amount", orderable: false },
  //       // { title: "Status", data: "Status", orderable: false },
  //       { title: " ", data: "View", orderable: false },
  //     ],
  //     destroy: true,
  //     searching: true,
  //     dom: "<'row'l<'col-sm-12'b>><'row'<'col-sm-12 mt-2'p><'col-sm-12'>>",
  //     lengthMenu: [10, 20, 50],
  //     lengthChange: true,
  //     ordering: false,
  //     language: {
  //       paginate: {
  //         previous: "<",
  //         next: ">",
  //       },
  //     },
  //   });

  //   $("#searchInput").on("input", function () {
  //     table.search(this.value).draw();
  //   });

  //   return () => {
  //     table.destroy();
  //   };
  // }, [inStoreOrder]);

  // for table End

  function capitalizeFirstLetter(
    string,
    m_status,
    payment_id,
    pax_details,
    is_split_payment,
    card_type
  ) {
    // return string.charAt(0).toUpperCase() + string.slice(1);
    return payment_id !== "Cash" && is_split_payment == "0"
      ? "Credit Card"
      : card_type === "" && payment_id == "Cash"
        ? "Cash"
        : is_split_payment == "1"
          ? "Split"
          : "";
  }

  function getPaymentType(
    order_status,
    payment_id,
    is_split_payment,
    card_type
  ) {
    // Unpaid order
    if (order_status === "open") return "Unpaid";

    // Split payment has highest priority
    if (is_split_payment == "1") return "Split";

    // EBT payment types
    if (card_type?.toLowerCase().includes("food")) return "Food EBT";
    if (card_type?.toLowerCase().includes("cash")) return "Cash EBT";
    if (card_type?.toLowerCase().includes("credit")) return "Credit Card";
    if (card_type?.toLowerCase().includes("debit")) return "Debit Card";
    // Regular payments
    if (payment_id === "Cash" && card_type === "") return "Cash";
    // if (payment_id !== "Cash" && payment_id !== "" && is_split_payment == "0")
    //   return "Credit Card";

    return "";
  }

  const tableRow = [
    "Customer",
    "Employee",
    "Order Date/Time",
    "Order ID",
    "Amount",
  ];
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [sortOrder, setSortOrder] = useState("desc"); // "asc" for ascending, "desc" for descending
  // console.log("sortOrder", sortOrder);
  const [filter_by, setFilter_by] = useState("merchant_time");
  const sortByItemName = async (type, filter_by) => {
    // const { sortedItems, newOrder } = SortTableItemsHelperFun(
    //   inStoreOrder,
    //   type,
    //   name,
    //   sortOrder
    // );
    // setFilter_by(name)
    // setAllInStoreOrders(sortedItems);
    // setSortOrder(newOrder);
    const transactionType = (type) => {
      if (type === "Cash") {
        return "Cash";
      } else if (type === "Credit Card") {
        return "Online";
      } else if (type === "Cash & Credit Card") {
        return "Both";
      } else {
        return type;
      }
    };
    setCurrentPage(1);
    if (props?.selectedDateRange?.start_date) {
      let data = {
        merchant_id: props.merchant_id,
        order_type: "Offline",
        // trans_type: transactionType(props.OrderSourceData),
        trans_type: "Both", //
        start_date: props.selectedDateRange?.start_date,
        end_date: props.selectedDateRange?.end_date,
        // emp_id:
        //   props?.EmployeeIDData === "All Employees"
        //     ? "All"
        //     : props?.EmployeeIDData,
        emp_id:
          // props?.selectedInStoreEmployeeList.length !== 0
          //   ? props?.selectedInStoreEmployeeList
          //       .map((emp) => `${emp.id}`)
          //       .join(",")
          //   : "All",
          props?.employeeList.length ===
          props.selectedInStoreEmployeeList.length
            ? "All"
            : props?.selectedInStoreEmployeeList.length !== 0
              ? props?.selectedInStoreEmployeeList
                  .map((emp) => `${emp.id}`)
                  .join(",")
              : "",
        search_by:
          props?.OffSearchIdData !== "" ? props?.OffSearchIdData : null,
        perpage: rowsPerPage,
        page: 1, //debouncedValue === "" ? currentPage : "1",
        order_method: props.order_method ? props.order_method : "All",
        payment_type:
          // Same rule as fetchData; empty selection falls back to "All"
          // (pre-existing behavior of this sort path).
          props?.enhancedInStoreTransactionsList.length ===
          props?.selectedInStoreTransactionsList.length
            ? "All"
            : props.selectedInStoreTransactionsList.length > 0
              ? props.selectedInStoreTransactionsList
                  ?.map((item) => item.apivalue)
                  .join(", ")
              : "All",
        order_by: (sortOrder === "asc" ? "desc" : "asc").toUpperCase(),
        filter_by:
          filter_by === "name"
            ? `users.${filter_by}`
            : filter_by === "f_name"
              ? `employee.${filter_by}`
              : `my_order.${filter_by}`,
      };
      // console.log("date data", data);
      if (data) {
        try {
          await dispatch(fetchInStoreOrderData(data)).unwrap();
          setFilter_by(filter_by);
          // setAllInStoreOrders(sortedItems);
          setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
        } catch (error) {
          if (error?.status == 401) {
            getUnAutherisedTokenMessage();
            handleCoockieExpire();
          } else if (error?.status == "Network Error") {
            getNetworkError();
          }
        }
      }
    }
  };

  return (
    <>
      <Grid container className="box_shadow_div">
        <Grid item xs={12}>
          <Grid container sx={{ py: 2.5, px: { xs: 1, sm: 2.5 } }}>
            <Grid item xs={12}>
              <Pagination
                currentPage={currentPage}
                totalItems={totalCount}
                itemsPerPage={rowsPerPage}
                onPageChange={paginate}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                setCurrentPage={setCurrentPage}
                showEntries={true}
                data={AllInStoreDataState?.inStoreOrderData}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              {AllInStoreDataState.loading ? (
                <SkeletonTable columns={tableRow} />
              ) : (
                <>
                  <TableContainer>
                    <StyledTable
                      sx={{ minWidth: 500 }}
                      aria-label="customized table"
                    >
                      <TableHead>
                        {/* {tableRow.map((item, index) => (
                          <StyledTableCell key={item}>{item}</StyledTableCell>
                        ))}
                         */}
                        <StyledTableCell>
                          <button
                            className="flex items-center"
                            onClick={() =>
                              sortByItemName("str", "billing_name")
                            }
                          >
                            <p className="whitespace-nowrap">Customer</p>
                            <HoverInfoLogo
                              title={"Name and contact details of the customer"}
                            />
                            <img src={sortIcon} alt="" className="pl-1" />
                          </button>
                        </StyledTableCell>
                        <StyledTableCell>
                          {" "}
                          <button
                            className="flex items-center"
                            onClick={() => sortByItemName("date", "f_name")}
                          >
                            <p>Employee</p>
                            <HoverInfoLogo title={"Employee name"} />
                            <img src={sortIcon} alt="" className="pl-1" />
                          </button>
                        </StyledTableCell>
                        <StyledTableCell>
                          <button
                            className="flex items-center"
                            onClick={() =>
                              sortByItemName("date", "merchant_time")
                            }
                          >
                            <p>Order Date/Time</p>
                            <HoverInfoLogo title={"Order timestamp"} />
                            <img src={sortIcon} alt="" className="pl-1" />
                          </button>
                        </StyledTableCell>
                        <StyledTableCell>
                          <button
                            className="flex items-center"
                            onClick={() => sortByItemName("id", "order_id")}
                          >
                            <p>Order ID</p>
                            <HoverInfoLogo
                              title={"Unique identifier for the order"}
                            />
                            <img src={sortIcon} alt="" className="pl-1" />
                          </button>
                        </StyledTableCell>
                        <StyledTableCell>
                          <button
                            className="flex items-center"
                            onClick={() => sortByItemName("num", "amt")}
                          >
                            <p>Amount</p>
                            <HoverInfoLogo
                              title={"Total amount of the order"}
                            />
                            <img src={sortIcon} alt="" className="pl-1" />
                          </button>
                        </StyledTableCell>
                      </TableHead>
                      <TableBody>
                        {inStoreOrder &&
                        Array.isArray(inStoreOrder) &&
                        inStoreOrder.length > 0
                          ? inStoreOrder?.map((data, index) => (
                              <StyledTableRow key={index}>
                                <StyledTableCell>
                                  {data.billing_name || data.delivery_phn ? (
                                    <>
                                      <p className="text-[#000000] order_method text-">
                                        {/* <Link
                                          to={`/customer/view-customer?customer_id=${data?.customer_id}&email=${
                                            data?.email
                                          }&phone=${data?.delivery_phn}`}
                                          className="text-[#0A64F9]"
                                          target="_blank"
                                        >
                                          {data.billing_name || ""}
                                        </Link> */}
                                        {data.billing_name || ""}
                                      </p>
                                      <p className="text-[#818181]">
                                        {data.email || ""}
                                      </p>
                                      <p className="text-[#818181]">
                                        {formatPhoneNumber(data.delivery_phn) ||
                                          ""}
                                      </p>
                                    </>
                                  ) : (
                                    <div>
                                      <p>Walk-In Customer</p>
                                    </div>
                                  )}
                                </StyledTableCell>
                                <StyledTableCell>
                                  {data.f_name} {data.l_name}
                                </StyledTableCell>
                                <StyledTableCell>
                                  <p className="">
                                    {data.merchant_time
                                      ? format(
                                          new Date(data.merchant_time),
                                          "MM/dd/yyyy hh:mm a"
                                        )
                                      : ""}
                                  </p>
                                </StyledTableCell>
                                <StyledTableCell>
                                  <Link
                                    to={`/order/store-reporting/order-summary/${props.merchant_id}/${data?.order_id}`}
                                    target="_blank"
                                    className="text-[#0a64f9] order_method  cursor-pointer"
                                  >
                                    {data.order_id || ""}
                                  </Link>

                                  {/* <p className="text-[#818181]">
                                    {data.order_method || ""}
                                  </p> */}
                                </StyledTableCell>

                                <StyledTableCell>
                                  <p> {"$" + data.amt || ""}</p>
                                  <p className="text-[#1EC26B]">
                                    {/* {capitalizeFirstLetter(
                                      data.order_status || "",
                                      data.m_status || "",
                                      data.payment_id || "",
                                      data.pax_details || "",
                                      data.is_split_payment || "",
                                      data?.card_type || ""
                                    )} */}
                                  </p>
                                  <p className="text-[#1EC26B]">
                                    {getPaymentType(
                                      data?.order_status,
                                      data.payment_id,
                                      data.is_split_payment,
                                      data.card_type
                                    )}
                                  </p>
                                </StyledTableCell>
                                {/* <StyledTableCell> */}
                                {/* <p
                                  onClick={() =>
                                    navigate(
                                      `/order/store-reporting/order-summary/${"MAL0100CA"}/${data.order_id}`
                                    )
                                  }
                                  // href="/store-reporting/order-summary/${data.order_id}"
                                  className="view_details_order"
                                >
                                  View Details
                                </p> */}
                                {/* <Link
                                    className="whitespace-nowrap text-[#0A64F9]"
                                    to={`/order/store-reporting/order-summary/${props.merchant_id}/${data?.order_id}`}
                                    // onClick={() => handleSummeryPage(row.order_id)}
                                    target="_blank"
                                  >
                                    View Details */}
                                {/* Order Summery */}
                                {/* <img src={Summery} alt="" className="pl-1" /> */}
                                {/* </Link> */}
                                {/* </StyledTableCell> */}
                              </StyledTableRow>
                            ))
                          : ""}
                      </TableBody>
                    </StyledTable>
                    {!inStoreOrder.length && <NoDataFound table={true} />}
                  </TableContainer>
                </>
              )}
            </Grid>
          </Grid>
          <Grid container sx={{ py: 2.5, px: { xs: 1, sm: 2.5 } }}>
            <Grid item xs={12}>
              <Pagination
                currentPage={currentPage}
                totalItems={totalCount}
                itemsPerPage={rowsPerPage}
                onPageChange={paginate}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                setCurrentPage={setCurrentPage}
                showEntries={false}
                data={AllInStoreDataState?.inStoreOrderData}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* <div className="q-attributes-bottom-detail-section">
        <div className="q-attributes-bottom-header-sticky">
          <table className="" id="InstoreTable"></table>
        </div>
      </div> */}
    </>
  );
};

export default InstoreTableViewData;
